import React from "react";
import Dashboard from "../../common/Dashboard";
import DashboardConfig from "../system-admin/Dashboard/DashboardConfig";

export default function GMAdminDashboard() {
  return (
    <Dashboard sidebarType="General Manager">
      <DashboardConfig />
    </Dashboard>
  );
}
